// extracted by mini-css-extract-plugin
export var heroContainer = "styles-module__heroContainer___qa0mk";
export var heroMessage = "styles-module__heroMessage___wWP1g";
export var contentContainer = "styles-module__contentContainer___KThSV";
export var giftCards = "styles-module__giftCards___KVTmB";